export const validateUser = async ({ env, setUser, userAuth, setIsValid, setIsLoading }) => {
	const tg = window?.Telegram?.WebApp;

	console.log('[validateUser] Starting validation, env:', env);
	
	if(tg){
		await tg.ready();
		tg.expand();
		tg.disableVerticalSwipes();
	}

	if (env === 'prod') {
		const user = tg?.initDataUnsafe?.user;
		console.log('[validateUser] User from Telegram:', user);
		console.log('[validateUser] initData available:', !!tg?.initData);
		
		try {
			const apiUrl = `${process.env.REACT_APP_API_URL_PROD}/api/validate`;
			console.log('[validateUser] Validating at:', apiUrl);
			
			const res = await fetch(apiUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ initData: tg.initData }),
			});

			console.log('[validateUser] Response status:', res.status);
			const data = await res.json();
			console.log('[validateUser] Response data:', data);
			
			if (data === 'Valid init data') {
				sessionStorage.setItem('initData', tg?.initData);
				setUser(user);
				await userAuth(Number(user?.id));
				setIsValid(true);
				console.log('[validateUser] Validation successful');
			} else {
				console.error('[validateUser] Validation failed: invalid response', data);
				setIsValid(false);
			}
		} catch (error) {
			console.error('[validateUser] Validation error:', error);
			setIsValid(false);
		} finally {
			setIsLoading(false);
		}
	} else {
		console.log('[validateUser] Dev mode, using mock user');
		const user = {
			id: 789166622,
			first_name: "k",
			last_name: null,
			username: null,
			language_code: "ru",
			allows_write_to_pm: true
		};
		sessionStorage.setItem('initData', window.Telegram?.WebApp.initData || process.env.REACT_APP_DEV_INIT_DATA);
		setUser(user);
		await userAuth(user.id);
		setIsValid(true);
		setIsLoading(false);
		console.log('[validateUser] Dev validation successful');
	}
};